<template>
    <DFormRow
        :label="__('customers.contracts.fulfillment_lead_time')"
        :error="errors.lead_time"
        :is-required="required"
    >
        <DInput
            id="lead_time"
            :model-value="modelValue"
            type="number"
            min="0"
            @update:modelValue="$emit('update:modelValue', $event)"
            @update:value="$emit('valueChanged')"
        />
    </DFormRow>
</template>

<script>
export default {
    name: 'LeadTime',
    props: {
        modelValue: {
            type: [String, Number],
            default: 0
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    emits: ['valueChanged', 'update:modelValue']
}
</script>
